import { Avatar, Grid, Stack, Typography } from '@mui/material';
import { IPayslips } from 'API/Paychecks/paychecks';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';

import { useDictionary, useIsDesktop } from 'Hooks';
import { PurpleArrowDown2, PurpleArrowUp } from 'Images';
import { useState } from 'react';
import { CardPaycheck } from '../CardPaycheck';

interface ITabPaychecks {
  data: IPayslips[];
}

export const TabPaychecks = ({ data }: ITabPaychecks) => {
  const [showAll, setShowAll] = useState(false);
  const dictionary = useDictionary(Dictionary, DICTIONARY.Paychecks);
  const isDesktop = useIsDesktop();
  const MAX_ITEMS = 12;

  return (
    <>
      <Grid container spacing={isDesktop ? '32px' : '20px'}>
        {data &&
          data?.slice(0, MAX_ITEMS).map((item: IPayslips, index: number) => {
            return (
              <Grid item xs={isDesktop ? 6 : 12} key={index}>
                <CardPaycheck cardData={item} isActive={index === 0} />
              </Grid>
            );
          })}
      </Grid>
      {data?.length > MAX_ITEMS &&
        (!showAll ? (
          <Stack
            component={'a'}
            marginTop={'20px'}
            direction={'row'}
            justifyContent={'center'}
            alignItems={'center'}
            sx={{ cursor: 'pointer' }}
            onClick={() => setShowAll(!showAll)}
          >
            <Typography variant='body5' color='primary.main'>
              {dictionary.previousPaychecks}
            </Typography>
            <Avatar
              src={PurpleArrowDown2}
              alt={''}
              sx={{ width: '50px', height: '44px' }}
            />
          </Stack>
        ) : (
          <Stack marginTop={'20px'}>
            <Typography variant='body1'>
              {dictionary.previousPaychecks}
            </Typography>
          </Stack>
        ))}
      {showAll && data?.length > MAX_ITEMS && (
        <Stack>
          <Grid container spacing={isDesktop ? '32px' : '20px'}>
            {data &&
              data
                ?.slice(MAX_ITEMS, data.length)
                .map((item: IPayslips, index: number) => {
                  return (
                    <Grid item xs={isDesktop ? 6 : 12} key={index}>
                      <CardPaycheck cardData={item} />
                    </Grid>
                  );
                })}
          </Grid>
          <Stack
            component={'a'}
            marginTop={'40px'}
            direction={'row'}
            justifyContent={'center'}
            alignItems={'center'}
            gap={'8px'}
            sx={{ cursor: 'pointer' }}
            onClick={() => setShowAll(!showAll)}
          >
            <Typography variant='body5' color='primary.main'>
              {dictionary.toggleClose}
            </Typography>
            <Avatar
              src={PurpleArrowUp}
              alt={''}
              sx={{ width: '50px', height: '44px' }}
            />
          </Stack>
        </Stack>
      )}
    </>
  );
};
